import React from 'react';
import Button from 'devextreme-react/button';

import CoreUtils from '../../../common/utils/CoreUtils';

import BooleanEditor from '../../../common/metadata/BooleanEditor';
import NumberEditor from '../../../common/metadata/NumberEditor';
import SelectEditor from '../../../common/metadata/SelectEditor';

import DataItemView from '../../../common/view/DataItemView';
import ModifiedFlag from '../../../common/controls/ModifiedFlag';
import ErrorFlag from '../../../common/controls/ErrorFlag';

export default class ContractAlertView extends DataItemView {
  static displayName = ContractAlertView.name;

  constructor(props) {
    super(props);

    this.onEditorValueListener = this.onEditorValueChanged.bind(this);
    this.bindDataItem(props.contractAlert);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.contractAlert);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    return (
      <div className={this.getContractAlertViewClassNames(this.state.isDeleted)}>
        <table><tbody>
          <tr>
            <td className="pwx-contract-section-inline-parameter" colSpan="7">
              <span className="pwx-contract-section-inline-label">Is Active:</span>
              <BooleanEditor name="isActive" value={this.state.isActive} onValueChanged={this.onEditorValueListener} />
              <ModifiedFlag isModifiedProperty={this.state.isActive_isModified} />
              <ErrorFlag errorProperty={this.state.isActive_error} />
            </td>
          </tr>
          <tr>
            <td colSpan="3">Alert Audience:</td>
            <td colSpan="3">Alert Image:</td>
            <td></td>
          </tr>
          <tr>
            <td className="pwx-select-box">
              <SelectEditor
                options={this.state.alertAudience_options}
                displayExpr="displayValue"
                height="24px"
                name="alertAudience"
                showClearButton={false}
                value={this.state.alertAudience}
                onValueChanged={this.onEditorValueListener}
                width="190px"
              />
            </td>
            <td>
              <ModifiedFlag isModifiedProperty={this.state.alertAudience_isModified} />
              <ErrorFlag errorProperty={this.state.alertAudience_error} />
            </td>
            <td className="pwx-contract-range-gap" />
            <td className="pwx-select-box">
              <SelectEditor
                options={this.state.alertImage_options}
                displayExpr="displayValue"
                height="24px"
                name="alertImage"
                showClearButton={false}
                value={this.state.alertImage}
                onValueChanged={this.onEditorValueListener}
                width="180px"
              />
            </td>
            <td>
              <ModifiedFlag isModifiedProperty={this.state.alertImage_isModified} />
              <ErrorFlag errorProperty={this.state.alertImage_error} />
            </td>
            <td className="pwx-contract-range-gap" />
            <td>
              <span className="pwx-contract-range-remove">
                <Button type="normal" icon="remove" disabled={this.state.scheduleCount > 0} onClick={this.onRemoveButtonClicked.bind(this)} />
              </span>
            </td>
          </tr>
          <tr>
            <td className="pwx-contract-section-inline-parameter" colSpan="3">
              <span className="pwx-contract-section-inline-label">Replace Previous Alert:</span>
              <BooleanEditor name="replacePreviousAlert" value={this.state.replacePreviousAlert} onValueChanged={this.onEditorValueListener} />
              <ModifiedFlag isModifiedProperty={this.state.replacePreviousAlert_isModified} />
              <ErrorFlag errorProperty={this.state.replacePreviousAlert_error} />
            </td>
            <td className="pwx-contract-section-inline-parameter" colSpan="4">
              <span className="pwx-contract-section-inline-label">AutoClose Interval:</span>
              <NumberEditor name="autoCloseIntervalSeconds" width="58px" value={this.state.autoCloseIntervalSeconds} onValueChanged={this.onEditorValueListener} />
              <span className="pwx-contract-section-inline-label">&nbsp;(s)</span>
              <ModifiedFlag isModifiedProperty={this.state.autoCloseIntervalSeconds_isModified} />
              <ErrorFlag errorProperty={this.state.autoCloseIntervalSeconds_error} />
            </td>
          </tr>
        </tbody></table>
      </div>
    );
  }

  getContractAlertViewClassNames(isDeleted) {
    var classNames = 'pwx-contract-section-view';
    if (isDeleted)
      classNames += ' pwx-item-deleted';

    return classNames;
  }

  onEditorValueChanged(propertyName, value) {
    if (this.dataItem !== null)
      this.dataItem.updateProperty(propertyName, value);
  }

  onRemoveButtonClicked() {
    if (CoreUtils.isDefinedAndNotNull(this.props.onRemoveContractAlert))
      this.props.onRemoveContractAlert(this.dataItem);
  }
}